<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
}
</script>
<style lang="scss">
.map {
  width: 100%;
  height: 100vh;
}
@font-face {
  font-family: 'snowhow';
  src:  url('./assets/css/fonts/snowhow.eot?747sdv');
  src:  url('./assets/css/fonts/snowhow.eot?747sdv#iefix') format('embedded-opentype'),
    url('./assets/css/fonts/snowhow.ttf?747sdv') format('truetype'),
    url('./assets/css/fonts/snowhow.woff?747sdv') format('woff'),
    url('./assets/css/fonts/snowhow.svg?747sdv#snowhow') format('svg');
  font-weight: normal;
  font-style: normal;
}
@import "../node_modules/leaflet/dist/leaflet.css";
@import "./assets/css/iconfont.scss";
.awsIcon, .freerideinfo, .partner {
  background-color: white;
  font-size: 2rem;
}
.icon-noexit, .icon-dangerous, .icon-noreturn, .icon-crevasse {
  color: red;
}
.webcamIcon {
  width: 300px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  margin: 0;
  padding: 0;
}
body {
  margin: 0;
  padding: 0;
}
</style>